import { render, staticRenderFns } from "./ivestor-apple-pay.vue?vue&type=template&id=478cb0eb"
import script from "./ivestor-apple-pay.vue?vue&type=script&lang=js"
export * from "./ivestor-apple-pay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/apple-pay-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Fivestor-apple-pay.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/apple-pay-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Fivestor-apple-pay.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,HalfImageHalfGridTwo: require('/vercel/path0/components/HalfImageHalfGridTwo.vue').default,FaqsAccordion: require('/vercel/path0/components/datablocks/FaqsAccordion.vue').default})
